export enum AUTH_COOKIES {
  ACCESS_TOKEN = "ACCESS_TOKEN",
  REFRESH_TOKEN = "REFRESH_TOKEN",
  /* eslint-disable @typescript-eslint/naming-convention */
  kk_customer_id = "kk_customer_id",
}
export const ANON_USER_ID = "katkin-user-token";

/**
 * Access token duration in seconds (1 hour)
 * Used across all apps for consistent token expiry configuration
 */
export const ACCESS_TOKEN_DURATION_SECONDS = 120;

/**
 * Refresh token duration in years (1 year)
 * Used across all apps for consistent refresh token expiry configuration
 */
export const REFRESH_TOKEN_DURATION_YEARS = 1;
